import { render } from "./SiteManagerMenu.vue?vue&type=template&id=f4e3b7d6&scoped=true&ts=true"
import script from "./SiteManagerMenu.vue?vue&type=script&lang=ts"
export * from "./SiteManagerMenu.vue?vue&type=script&lang=ts"

import "./SiteManagerMenu.vue?vue&type=style&index=0&id=f4e3b7d6&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SiteManagerMenu.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./SiteManagerMenu.vue?vue&type=custom&index=1&blockType=i18n&locale=fr"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4e3b7d6"]])

export default __exports__